import axios from 'axios'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

// Axios 인스턴스 생성
const axiosInstance = axios.create({
	baseURL: API_ENDPOINT,
})

// 응답 인터셉터: 토큰 만료 시 자동 로그아웃
axiosInstance.interceptors.response.use(
	(response) => {
		// 성공 응답은 그대로 반환
		return response
	},
	(error) => {
		// 401 또는 403 에러 시 (토큰 만료 또는 인증 실패)
		if (error.response && (error.response.status === 401 || error.response.status === 403)) {
			console.warn('토큰이 만료되었거나 인증에 실패했습니다. 로그아웃 처리합니다.')

			// 커스텀 이벤트 발생시켜서 AuthProvider가 처리하도록 함
			window.dispatchEvent(new CustomEvent('auth:logout'))
		}

		return Promise.reject(error)
	},
)

export default axiosInstance
